<template>

    <div class="brt-map-navTipModule" :class="{route:brtmap.$route.route && brtmap.$route.route.length>1 && !brtmap.$route.vehicle && !brtmap.$route.isExit}" ref="navTipModule">

        <div class="route-floorType-module">
            <div v-for="(item,index) in routeSelect" :class="index == routeIndex?'wrap active':'wrap'" @click="changeRoute(index,item)" >
                <i :class="'iconfont icon-'+item.icon"></i>
                <span>{{item.name}}</span>
            </div>
        </div>

        <div class="wrap-section">

            <!--加载-->
            <div class="loading-box" v-if="$store.state.mapStore.isShow(moduleState,[0])">

                <i class="iconfont icon-loading"></i>
                <span>请稍侯...</span>

            </div>

            <!--信号中断-->
            <div class="loading-box red" v-if="$store.state.mapStore.isShow(moduleState,[3])">

                <i class="iconfont icon-loading"></i>
                <span>设备信号断开<br/>搜索中....</span>

            </div>

            <!--偏转路线-->
            <div class="loading-box red" v-if="$store.state.mapStore.isShow(moduleState,[4])">

                <i class="iconfont icon-loading"></i>
                <span>已偏离路线<br/>重新规划中....</span>

            </div>

            <!--设备信号弱-->
            <div class="loading-box red" v-if="$store.state.mapStore.isShow(moduleState,[5])">

                <i class="iconfont icon-loading"></i>
                <span>设备信号弱<br/>位置可能偏差....</span>

            </div>

            <!--到达终点-->
            <div class="loading-box normal" v-if="$store.state.mapStore.isShow(moduleState,[6])">

                <span class="icon-endIcon"></span>
                <span>你已到达终点附近....</span>

            </div>

            <div class="tip-box" v-if="$store.state.mapStore.isShow(moduleState,[1,2])">

                <div class="tip-icon" :type='directionType'></div>

                <!--:class=" isTure  ? 'direction':'distance'"-->
                <div class="tip-txt">
                    <p class="distance" v-if="distance > tureRange">{{distance}}米后</p>
                    <p  class="direction">{{direction}}</p>
                </div>

            </div>

            <div class="rssi-box" v-if="$store.state.mapStore.isShow(moduleState,[1,2])">

                <div class="walk" v-show="moduleState == 1" :state="rssi">
                    <span v-if="rssi == 0">断</span>
                    <span v-else-if="rssi == 1">弱</span>
                    <span v-else>强</span>
                    <i class="iconfont icon-rssi"></i>
                </div>

                <div class="analog" v-show="moduleState == 2">模拟导航中</div>
            </div>
        </div>

        <div class="progress-section">

            <div class="step-box">

                <div :class="passed(index)?'box passed':'box'"  v-for = "(item,index) in progress.routes"  :style="{width:(item.currentDistant/progress.totalDistan)*100 +'%'}">
                    <span><i :class="'iconfont icon-'+item.icon" v-if="item.icon"></i> <span>{{item.floorName}}</span></span>
                </div>

            </div>

            <div class="bar-box">

                <div class="box">
                    <i :class="['iconfont',!brtmap.existVehicle?'icon-walk':'icon-cheliangguanli']" ref="walkICON" :style="{left:getLeft}" ></i>
                </div>

                <i class="bar" :style="{left:(progress.passedDistan/progress.totalDistan)*100 +'%'}"></i>
            </div>

        </div>

        <div class="progress-img" v-if="toolImg">
            <img :src="toolImg" alt="">
        </div>
    </div>

</template>

<script>
    import {mapState} from 'vuex';
    export default {
        name: "NavTipModule",
        data(){
            return {
                moduleState:0,
                distance:0,
                directionType:'',  //方向
                direction:'',
                rssi:0,     //信号强弱 0断开 1弱 2强

                init:false,

                tureRange:1,

                floors:[],

                toolImg:'',

                progress:{  //进度条

                    totalDistan:100,

                    passedDistan:0,

                    routes:[
                        {
                            floorName:'起',
                            currentDistant:100,
                            icon:''
                        },
                        //
                        // {
                        //     floorName:'L1',
                        //     currentDistant:100,
                        //     icon:'up'
                        // },
                        //
                        // {
                        //     floorName:'L1',
                        //     currentDistant:100,
                        //     icon:'down'
                        // },
                        // {
                        //     floorName:'L1',
                        //     currentDistant:100,
                        //     icon:'down'
                        // }
                    ],
                },

                routeIndex:0,
                routeSelect:[
                    {
                        name:'距离最短',
                        icon:'juli',
                        ignor:[],
                    },
                    {
                        name:'直梯',
                        icon:'elevator-02',
                        ignor:['150012','150014'],
                    },
                    {
                        name:'扶梯',
                        icon:'elevator-01',
                        ignor:['150012','150013'],
                    },
                    {
                        name:'楼道',
                        icon:'elevator-03',
                        ignor:['150013','150014'],
                    }
                ],
            }
        },


        created(){

            this.bus.$off('navtopSet');

            this.bus.$on('navtopSet',(res)=>{
                // console.log('头部设置',res);

                if(!res.status){

                    this.changeBar(Object.assign({},res));

                }

                else{ //偏航

                    if(res.status == 1){

                        this.moduleState = 4;

                    }

                    else if(res.status == 2){

                        this.moduleState = 6;

                    }

                    else if(res.status == 3){

                        //初始化$data
                        Object.assign(this.$data,this.$options.data())

                    }

                    else if(res.status == 4){
                        this.init = false;
                    }
                }
            })
        },


        methods:{
            passed(index){
                let $this=this,$distant = 0;

                for(var i=0;i<index;i++){
                    $distant +=$this.progress.routes[i].currentDistant;
                }

                // console.log('$distant',$distant);

                if($this.progress.passedDistan - $distant < 0)return false;
                return true;

            },

            changeBar(v1){

                if(v1.route){  //初始数据处理

                    if(!this.init){

                        this.init = true;

                        let floorDistant = 0,lastfloor,$floors=[];
                        this.$floors =[];

                        for(let i = 0; i<v1.route.length;i++){

                            for(let j =0 ; j<v1.route[i].detail.length;j++){

                                let _route=v1.route[i].detail[j].route;

                                for(let k=0;k<_route.length-1;k++){

                                    let _point1 = $VAR.map.lnglatToCoords(_route[k][0], _route[k][1]),
                                        _point2 = $VAR.map.lnglatToCoords(_route[k+1][0], _route[k+1][1]),
                                        _d = Math.sqrt((_point1.x - _point2.x) * (_point1.x - _point2.x) + (_point1.y - _point2.y) * (_point1.y - _point2.y));

                                    floorDistant += _d;
                                }
                            }


                            if(v1.route[i-1] && v1.route[i-1].floor){

                                if(v1.route[i].floor > v1.route[i-1].floor){
                                    $floors.push({currentDistant:floorDistant,floorName:$VAR.map.getFloorInfoByIndex(v1.route[i].floor).floorName,icon:'up'})
                                }else{
                                    $floors.push({currentDistant:floorDistant,floorName:$VAR.map.getFloorInfoByIndex(v1.route[i].floor).floorName,icon:'down'});
                                }

                            }else{

                                $floors.push({currentDistant:floorDistant,floorName:$VAR.map.getFloorInfoByIndex(v1.route[i].floor).floorName,icon:''});

                            }

                            floorDistant=0;
                        }

                        this.floors = $floors;
                    }



                    this.progress.totalDistan = v1.total;

                    this.progress.passedDistan = v1.passed;

                    this.progress.routes = this.floors;

                    this.distance = v1.residue;

                    this.directionType = v1.direction;

                    this.direction = v1.directionTXT;

                    this.rssi = v1.rssi;


                    this.activeRouteWay(this.brtmap.$route.ignore);
                    // this.bus.$emit('navAndLocationTest',{toptest:'顶部测试'})

                    if(this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE' && this.moduleState !=2){
                        this.$nextTick(()=>{
                            this.moduleState=2
                        })
                    }
                    if(this.$BRT.$NAVTO.NAVType != 'NAVSIMULATE' && this.moduleState !=1){
                        this.$nextTick(()=>{
                            this.moduleState=1
                        })
                    }

                    // this.moduleState = this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE' ? 2 : 1;
                    // if(this.rssi == 0){
                    //
                    //     this.moduleState = 3
                    //
                    // }else if(this.rssi == 1){
                    //
                    //     this.moduleState = 5
                    //
                    // }else{
                    //     this.moduleState = this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE' ? 2 : 1;
                    // }

                }


                if(v1.passed){    //通过距离改变

                    this.progress.passedDistan = v1.passed;
                }

                if(v1.residue){ //当前段剩余

                    this.distance = v1.residue
                }

                if(v1.direction){  //方向改变

                    this.directionType = v1.direction;

                }

                if(v1.directionTXT){  //方向改变
                    this.direction = v1.directionTXT;
                }

                if(v1.rssi >=0){
                    this.rssi = v1.rssi;
                }


                //实景图标
                this.toolImg = '';

                if(v1.tool && v1.toUp){
                    if(v1.tool == '150012'){
                        //楼梯
                        if(v1.toUp === 1){
                            //上行
                            this.toolImg = require('@/assets/tool_04.jpg')
                        }else{
                            //下行
                            this.toolImg = require('@/assets/tool_05.jpg')
                        }

                    }else if(v1.tool == '150013'){

                        this.toolImg = require('@/assets/tool_01.jpg')

                    }else{

                        if(v1.toUp === 1){
                            //上行
                            this.toolImg = require('@/assets/tool_02.jpg')
                        }else{
                            //下行
                            this.toolImg = require('@/assets/tool_03.jpg')
                        }

                    }
                }


            },

            changeRoute(index,item){

                this.routeIndex = index;
                this.$BRT.$route.ignore = item.ignor;
                this.bus.$emit('navingToChangeRoute',1);

            },

            activeRouteWay(v1){
                //统一跨层标识
                this.routeSelect.map((item,index)=>{

                    let i1 = '';
                    item.ignor.map(child=>{
                        i1 +=child;
                    })

                    let i2 = '';
                    v1.map(child=>{
                        i2 +=child;
                    })

                    if(i1 == i2 && this.routeIndex != index){
                        this.routeIndex = index;
                    }
                })

            }
        },



        watch:{

            mapstep(v1,v2){

                if(v1 == 'toNAVING'){

                    this.init =false;
                    this.progress.routes[0].currentDistant= this.progress.totalDistan;
                    this.moduleState = 0;

                }
            },

            ignore(v1,v2){  //改变路径方式
                this.activeRouteWay(v1)
            },

            // NAVInfo(v1,v2){
            //     // console.log('监听导航变化',v1,v2);
            //
            //     if(!v1.route){this.moduleState = 0;return}  //被清空
            //
            //     if(!v2.route && v1.route){  //初始数据处理
            //
            //         let floorDistant = 0,$floors=[],lastfloor;
            //
            //         for(let i = 0; i<v1.route.length;i++){
            //
            //             for(let j =0 ; j<v1.route[i].detail.length;j++){
            //
            //                 let _route=v1.route[i].detail[j].route;
            //
            //                 for(let k=0;k<_route.length-1;k++){
            //
            //                     let _point1 = $VAR.map.lnglatToCoords(_route[k][0], _route[k][1]),
            //                         _point2 = $VAR.map.lnglatToCoords(_route[k+1][0], _route[k+1][1]),
            //                         _d = Math.sqrt((_point1.x - _point2.x) * (_point1.x - _point2.x) + (_point1.y - _point2.y) * (_point1.y - _point2.y));
            //
            //                     floorDistant += _d;
            //                 }
            //             }
            //
            //
            //             if(v1.route[i-1] && v1.route[i-1].floor){
            //
            //                 if(v1.route[i].floor > v1.route[i-1].floor){
            //                     $floors.push({currentDistant:floorDistant,floorName:$VAR.map.getFloorInfoByIndex(v1.route[i].floor).floorName,icon:'up'})
            //                 }else{
            //                     $floors.push({currentDistant:floorDistant,floorName:$VAR.map.getFloorInfoByIndex(v1.route[i].floor).floorName,icon:'down'});
            //                 }
            //
            //             }else{
            //
            //                 $floors.push({currentDistant:floorDistant,floorName:$VAR.map.getFloorInfoByIndex(v1.route[i].floor).floorName,icon:''});
            //
            //             }
            //
            //             floorDistant=0;
            //         }
            //
            //         this.progress.totalDistan = v1.total;
            //
            //         this.progress.passedDistan = v1.passed;
            //
            //         this.progress.routes = $floors;
            //
            //         this.distance = v1.residue;
            //
            //         this.directionType = v1.direction;
            //
            //         this.direction = v1.directionTXT;
            //
            //         this.rssi = v1.rssi;
            //
            //         this.moduleState = this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE' ? 2 : 1;
            //     }
            //
            //
            //     if(v1.passed){    //通过距离改变
            //
            //         this.progress.passedDistan = v1.passed;
            //     }
            //
            //     if(v1.residue){ //当前段剩余
            //
            //         this.distance = v1.residue
            //     }
            //
            //     if(v1.direction){  //方向改变
            //
            //         this.directionType = v1.direction;
            //
            //     }
            //
            //     if(v1.directionTXT){  //方向改变
            //
            //         this.direction = v1.directionTXT;
            //
            //     }
            //
            //     if(v1.rssi >=0){
            //
            //         this.rssi = v1.rssi;
            //     }
            // }
        },

        computed:{

            getLeft(){
                return  (this.progress.passedDistan/this.progress.totalDistan)*100 +'%';
            },

            mapstep(){
                return this.$mapStep.type;
            },

            isTure(){

                let $endD = JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.navigation).endDistance >=0 ? JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.navigation).endDistance : 6,
                $endT = this.progress.totalDistan  - this.progress.passedDistan - $endD;

                if(this.distance > this.tureRange || this.distance > $endT){

                    return true
                }else{
                    return false;
                }

            },

            ignore(){
                return this.brtmap.$route.ignore;
            },

            ...mapState({
                brtmap:state=>state.mapStore.brtmap
            })

            // NAVInfo(){
            //     return this.$BRT.$NAVTO.NAVInfo;
            // }
        },



        mounted:function () {

            this.progress.routes[0].currentDistant= this.progress.totalDistan;

            this.moduleState = 0;

            // let $this=this,
            //
            //     $test =window.setInterval(function () {
            //
            //     if($this.progress.passedDistan > $this.progress.totalDistan){window.clearInterval($test);return}
            //
            //     $this.progress.passedDistan+=1;
            //
            // },10)

        }
    }
</script>

<style lang="less">
    @import "NavTipModule.less";
</style>
